import { ImageContainer, Logo, Wrapper } from '@/components/loaders/LogoLoader/styled';

const LogoLoader = () => {
  return (
    <Wrapper>
      <ImageContainer>
        <Logo />
      </ImageContainer>
    </Wrapper>
  );
};

export default LogoLoader;
